

import { EnumTypeContact } from "../../../../utils/EnumApp"
import './InfosContacts.css'

const contactsEntries = Object.values(EnumTypeContact)

const InfosContacts = ({ item }) => {

    const renderLink = (paramItem) => {

        // Email
        if (paramItem.IdTypeContact === EnumTypeContact.Email.value) {

            let numFormatted = 'mailto:' + paramItem.Valeur

            return (
                <a className="txt-contact" target="_blank" href={numFormatted}>&nbsp;:&nbsp;{paramItem.Valeur}</a>
            )
        }

        // Tel
        let numFormatted = 'tel:' + paramItem.Valeur

        return (
            <a className="txt-contact" target="_blank" href={numFormatted}>&nbsp;:&nbsp;{paramItem.Valeur}</a>
        )
    }

    const renderItems = () => {

        if (item.Contacts == null) {
            return (
                <div className="txt-none">
                    Aucun contact renseigné
                </div>
            )
        }

        return (
            <ul className="contact-items">
                {item.Contacts.map(function (item, index) {
                    return (
                        <li key={index}>
                            <span>{contactsEntries.find(x => x.value.toString() === item.IdTypeContact.toString())?.label}</span>
                            {renderLink(item)}
                        </li>
                    )
                }, this)}
            </ul>
        )
    }

    return (
        <div className="infos-contacts">
            <div className="title">Contacts</div>
            {renderItems()}
        </div>
    )
}

export default InfosContacts